export const BUSINESS_DEMO_SUCCESS_BENEFIT_SIMPLIFY_MANAGEMENT = {
  "en": "Simplify user management to save time",
  "fr": "",
  "de": "",
  "es": "",
  "pt-br": "Simplify user management to save time",
  "it": "Simplify user management to save time",
  "ja": "Simplify user management to save time",
  "ko": "Simplify user management to save time",
  "nl": "Simplify user management to save time",
  "pt-pt": "Simplify user management to save time",
  "sv": "Simplify user management to save time",
  "zh": "Simplify user management to save time"
}